import type { SidebarEntry } from "@/api/sidebarEntryAPI";
import { getCustomerScopedPath, isInternalUrl } from "./customerPath";

type NavigationEntry = Extract<SidebarEntry, { type: "LINK" }>;

const linkClassName =
    "text-foreground flex px-5 py-2.5 transition-colors hover:bg-muted data-[status=active]:bg-muted";

export default function SidebarNavigationEntryLink({
    entry,
    customerId,
}: {
    entry: NavigationEntry;
    customerId: number;
}) {
    const content = (
        <span className="flex w-full min-w-0 items-center gap-2.5">
            <span className="min-w-0 flex-1">
                <span className="block truncate text-[14px] leading-[1.25] font-medium">
                    {entry.name}
                </span>
                {entry.productInstanceName ? (
                    <span className="text-muted-foreground mt-0.5 block truncate text-[11px] leading-[1.25]">
                        {entry.productInstanceName}
                    </span>
                ) : null}
            </span>
        </span>
    );

    if (entry.url && isInternalUrl(entry.url)) {
        return (
            <a href={getCustomerScopedPath(customerId, entry.url)} className={linkClassName}>
                {content}
            </a>
        );
    }

    return (
        <a href={entry.url ?? "#"} className={linkClassName}>
            {content}
        </a>
    );
}
